import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import HomePage from '../components/pages/HomePage.vue'
import AboutPage from '../components/pages/AboutPage.vue'
import CulturePage from '../components/pages/CulturePage.vue'
import RessourcesPage from '../components/pages/RessourcesPage.vue'
import SupportPage from '../components/pages/SupportPage.vue'
import ContactPage from '../components/pages/ContactPage.vue'
import PrivacyPage from '../components/pages/PrivacyPage.vue'
import TermsPage from '../components/pages/TermsPage.vue'
import LegalPage from '../components/pages/LegalPage.vue'

const routes = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/about', name: 'about', component: AboutPage },
  { path: '/culture', name: 'culture', component: CulturePage },
  { path: '/ressources', name: 'ressources', component: RessourcesPage },
  { path: '/support', name: 'support', component: SupportPage },
  { path: '/contact', name: 'contact', component: ContactPage },
  { path: '/privacy', name: 'privacy', component: PrivacyPage },
  { path: '/terms', name: 'terms', component: TermsPage },
  { path: '/legal', name: 'legal', component: LegalPage }
]

export default new VueRouter({
  //mode: 'history',
  //base: __dirname,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})